import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const NivusGuard = createFeatureGuard(Feature.Nivus);